import { RANK_SVGS } from './rankSvgs';

export function RankNumber({ rank, className }: { rank: number; className?: string }) {
  const xml = RANK_SVGS[rank];
  if (!xml) {
    return null;
  }
  const src = `data:image/svg+xml,${encodeURIComponent(xml)}`;
  return <img alt="" className={className} src={src} />;
}
